const labels = Object.freeze({
  HOME: 'Home',
  MY_ACTIONS: 'My Actions',
  MANAGE_DIGITAL_ASSETS: 'Manage Digital Assets',
  CONTACTS: 'Contacts',
  MY_ACCOUNT: 'My Account',
  HELP: 'Help',
  LOGIN: 'Login',
  LOG_OUT: 'Log Out',
  CANCEL: 'Cancel',
});

export default labels;
